import Session from "@/utils/Session";

class BaseService 
{
    /**
     * Check if a user has a session.
     * 
     * @return {Bool}
     */
    static hasSession()
    {
        return (new Session()).exists();
    }
}

export default BaseService;